// extracted by mini-css-extract-plugin
module.exports = {"status":"_VnWc9SwQfIxq7tJp9CVt"};